import type { StateCreator } from 'zustand'

import type { AppSlice } from '../appSlice'
import type { CapabilitySlice } from '../capabilitySlice'
import type { ChannelSlice } from '../channelSlice'
import type { DirtySlice } from '../dirtySlice'
import type { EditorSlice } from '../editorSlice'
import type { PostSlice } from '../postSlice/postSlice'

export interface SaveErrorsState {
  /**
   * Request-level ("general") save errors that don't belong to any single
   * channel, surfaced as a banner at the top of the composer. Per-channel save
   * errors are attached to their channel instead (see resolveContentItemErrors).
   */
  generalSaveErrors: string[]
}

export interface SaveErrorsActions {
  /** Replace the general save errors — a save reports its whole set at once. */
  setGeneralSaveErrors: (errors: string[]) => void
  /** Clear the general save errors — on a fresh save attempt and on success. */
  clearGeneralSaveErrors: () => void
}

export type SaveErrorsSlice = SaveErrorsState & SaveErrorsActions

export const createSaveErrorsSlice: StateCreator<
  AppSlice &
    CapabilitySlice &
    ChannelSlice &
    DirtySlice &
    EditorSlice &
    PostSlice &
    SaveErrorsSlice,
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  SaveErrorsSlice
> = (set) => ({
  generalSaveErrors: [],

  setGeneralSaveErrors: (errors): void =>
    set(
      (state) => {
        state.generalSaveErrors = errors
      },
      undefined,
      'saveErrorsSlice:setGeneralSaveErrors',
    ),

  clearGeneralSaveErrors: (): void =>
    set(
      (state) => {
        state.generalSaveErrors = []
      },
      undefined,
      'saveErrorsSlice:clearGeneralSaveErrors',
    ),
})
